import './index.scss';

import { OutrosProdutos } from '../../components/outros-produtos';
import { FlutuacaoMoedas } from '../../components/flutuacao-moedas';

import { ImportExport } from '../../components/select-protecao/import-export';
import { NDF } from '../../components/select-protecao/ndf';
import { SwapCambial } from '../../components/select-protecao/swap-cambial';
import { Tabs } from '../../../tabs';
import {useState} from 'react'

export const ProdutosProtecao = () => {
    const [tabId, setTabId] = useState(1)
    const tabs = [
        {
            id: 1,
            label: "Travas de importação e exportação",
            content: <ImportExport />,
        },
        {
            id: 2,
            label: "SWAP Cambial",
            content: <SwapCambial />,
        },
        {
            id: 3,
            label: "NDF (Non-Deliverable Forward)",
            content: <NDF />,
        },
    ];

    return (
        <div className='teste-cambio'>

            <div className='container-principal protecao'>
                <div className='sombra-title'>
                    <h1> [ Produtos de proteção ] </h1>
                </div>
            </div>
            <div className='dados-protecao'>
                <div>
                    <FlutuacaoMoedas />
                </div>
            </div>
            <div className='restdados-produtos-protecao'>
                <Tabs tabs={tabs} id={tabId} setId={setTabId}/>
            </div>
            <div>
                <OutrosProdutos />
            </div>

        </div>

    )

}
